import React from 'react'
import PropTypes from 'prop-types'
import { Card, ToggleButtonGroup, ToggleButton } from '@mui/material'
import T from 'T'

export const MARKER_TYPE = {
  WEEK_DAY: 'weekDay',
  ROUTE: 'route',
}

const MarkerTypeControl = ({ value, onChange, sx = {} }) => {
  return (
    <Card sx={{ ...sx }}>
      <ToggleButtonGroup value={value} exclusive onChange={onChange} aria-label="marker type" size="small">
        <ToggleButton value={MARKER_TYPE.WEEK_DAY} aria-label="week day">
          {T.WEEK_DAY}
        </ToggleButton>
        <ToggleButton value={MARKER_TYPE.ROUTE} aria-label="route">
          {T.ROUTE}
        </ToggleButton>
      </ToggleButtonGroup>
    </Card>
  )
}

MarkerTypeControl.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
}

export default MarkerTypeControl
